module.exports = __webpack_public_path__ + "static/media/ca.0efb6bf1.svg";